<template>
  <div class="text-center">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-input-group class="mb-2">
      <b-input v-model="nombre" placeholder="Buscar por nombre"></b-input>
    </b-input-group>
    <b-input-group class="mb-2">
      <b-input v-model="idPaciente" placeholder="Buscar por Id"></b-input>
    </b-input-group>
            <b-row>
                <b-col cols="5">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                        :max="new Date()"
                                        @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="5">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                          v-model="filtro.fechaFin"
                                         :max="filtro.fechaInicio.getDate() + diasMaximoMes > new Date() ? new Date(): filtro.fechaInicio.getDate() + diasMaximoMes"
                                         :min="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>
                <b-col class="mt-4" cols="2">
                  <b-button v-on:click="gePacientes">
                    Buscar
                    <font-awesome-icon icon="search"/>
                   </b-button>
                </b-col>
              </b-row>
    <div v-if="pacienteService.loading === true">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <b-table
        v-else
        :items="items"
        :fields="fiels"
        show-empty
        sticky-header
        striped responsive="sm"
    >
      <template #empty="scope">
        <p class="alert alert-warning"> No hay datos</p>
      </template>
      <template #cell(idPaciente)="row">
        <router-link :to="'/paciente/'+row.item.idPaciente">{{ row.item.idPaciente }}</router-link>
      </template>
      <template #cell(certificado)="row">
        <b-button
            v-if="row.item.certificado.length > 0"
            v-b-modal="'modal-certificados'+row.item.idPaciente"
        >
          {{ row.item.certificado.length }}
          <font-awesome-icon icon="eye"/>
        </b-button>
        <b-modal
            ok-title="Aceptar"
            cancel-title="Cerrar"
            size="xl"
            :id="'modal-certificados'+row.item.idPaciente"
            title="Certificados del paciente"
        >
          <ul>
            <li v-for="certificado in row.item.certificado" :key="certificado.idCertificado">
              <b-button
                  v-b-modal="'modal-certificado'+certificado.idCertificado"
              >{{ certificado.idCertificado }}</b-button>
              <b-modal
                  ok-title="Aceptar"
                  cancel-title="Cerrar"
                  size="xl"
                  :id="'modal-certificado'+certificado.idCertificado"
                  title="Certificado del paciente"
              >
                <VerCertificado :certificado="certificado" :plataforma="row.item.plataforma"/>
              </b-modal>
            </li>
          </ul>
        </b-modal>
      </template>
      <template #cell(asociados)="row">
        <b-form-checkbox v-if="row.item.asociados.length >0 " v-model="row.detailsShowing" @change="row.toggleDetails">
          Beneficiarios
        </b-form-checkbox>
        <div v-else>Sin beneficiarios</div>
      </template>
      <template #row-details="row">
        <b-table
            :fields="fielsSub"
            :items="getAsociados(row.item.asociados)"
        >
          <template #cell(idPaciente)="asociado">
            <router-link :to="'/paciente/'+asociado.item.idPaciente">{{ asociado.item.idPaciente }}</router-link>
          </template>
          <template #cell(certificado)="asociado">
            <b-button
                v-if="row.item.certificado.length > 0"
                v-b-modal="'modal-certificados-asociados'+asociado.item.idPaciente"
            >
              {{ row.item.certificado.length }}
              <font-awesome-icon icon="eye"/>
            </b-button>
            <b-modal
                ok-title="Aceptar"
                cancel-title="Cerrar"
                size="xl"
                :id="'modal-certificados-asociados'+asociado.item.idPaciente"
                title="Certificados del paciente"
            >
              <ul>
                <li v-for="certificado2 in asociado.item.certificado" :key="certificado2.idCertificado">
                  <b-button
                      v-b-modal="'modal-certificado'+certificado2.idCertificado"
                  >{{ certificado2.idCertificado }}</b-button>
                  <b-modal
                      ok-title="Aceptar"
                      cancel-title="Cerrar"
                      size="xl"
                      :id="'modal-certificado'+certificado2.idCertificado"
                      title="Certificado del paciente"
                  >
                    <VerCertificado :certificado="certificado2" :plataforma="row.item.plataforma"/>
                  </b-modal>
                </li>
              </ul>
            </b-modal>
          </template>
        </b-table>
      </template>
    </b-table>
    <b-pagination
        v-if="totalRegistros != undefined  && totalRegistros > 5"
        align="center"
        v-model="paginaActual"
        :total-rows="totalRegistros"
        :per-page="registrosPorPagina"
        aria-controls="my-table1"
    ></b-pagination>
  </div>
</template>

<script>
import {PacienteService} from "../../../apiServices/paciente/PacienteService";
import VerCertificado from "./VerCertificado";

export default {
  name: "DetallePoblacionPlan",
  components: {VerCertificado},
  props: {
    idPlan: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    buscarId: false,
    buscarNombre: true,
    nombre: null,
    idPaciente: null,
    items: [],
    fiels: [
      {key: 'idPaciente', label: 'Id Px'},
      {key: 'nombrePaciente', label: 'Nombre'},
      {key: 'certificado', label: 'Certificado de compra'},
      {key: 'asociados', label: 'Beneficiarios'},
      {key: 'parentesco', label: 'Parentesco'},
      {key: 'tipoAsegurado', label: 'Tipo de asegurado'},
      {key: 'plataforma', label: 'Plataforma'},
    ],
    fielsSub: [
      {key: 'idPaciente', label: 'Id Px'},
      {key: 'nombrePaciente', label: 'Nombre'},
      {key: 'certificado', label: 'Certificado de compra'},
      {key: 'parentesco', label: 'Parentesco'},
      {key: 'tipoAsegurado', label: 'Tipo de asegurado'},
      {key: 'plataforma', label: 'Plataforma'},
    ],
    pacienteService: new PacienteService(),
    hoy: new Date(),
    diasMaximoMes: null,
    filtro: {
        fechaInicio: new Date(),
        fechaFin: null
      },
    registrosPorPagina: 10,
    paginaActual: 1,
    totalRegistros: 0
  }),
  watch: {
    buscarId() {
      this.buscarNombre = !this.buscarId;
    },
    buscarNombre() {
      this.buscarId = !this.buscarNombre;
    },
    paginaActual(){
      this.gePacientes();
    }
  },
  methods: {
    getAsociados(asociados) {
      return asociados.map(a => {
        delete a.asociados;
        return a;
      })
    }, gePacientes() {
      let fechaActual = this.$moment(this.filtro.fechaInicio);
      let fechaF = this.$moment(this.filtro.fechaFin);
      let fechaInicial = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ");
      let fechaFinal = fechaF.format("YYYY-MM-DD[T]HH:mm:ssZ");

      let filtros = {
        idPlan: this.idPlan,
        idPaciente:this.idPaciente,
        fechaInicio:fechaInicial,
        fechaFin:fechaFinal,
        nombre:this.nombre,
        pagina: this.paginaActual-1
      }
        this.pacienteService.obtenerpacientesPorPlanYIdPaciente(filtros).then((pacientes) => {
          this.items = pacientes;
          this.totalRegistros = this.items[0].totalRegistros;
        })
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null; 
    },
  },

  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>
